import ImageTabContent from './ImageTabContent'
export default ImageTabContent
